import React from 'react';

import { angularizeWithProviders } from '../../../shared/providers';
import { CoachPasswordBlock } from '../../components/CoachPasswordBlock/CoachPasswordBlock';

type NgzPasswordTabProps = {
  userId: number;
  userEmail: string;
};

const NgzPasswordTab = ({ userId, userEmail }: NgzPasswordTabProps) => {
  return userId && userEmail ? (
    <CoachPasswordBlock userId={userId} userEmail={userEmail} />
  ) : null;
};

angularizeWithProviders(NgzPasswordTab, 'ngzPasswordTab', {
  userId: '<',
  userEmail: '<',
});
